import { render, staticRenderFns } from "./Poricy.vue?vue&type=template&id=12272614"
import script from "./Poricy.vue?vue&type=script&lang=js"
export * from "./Poricy.vue?vue&type=script&lang=js"
import style0 from "./Poricy.vue?vue&type=style&index=0&id=12272614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports